import React from 'react';

// Component Styles
import './pageTitle.scss';

export default function PageTitle() {
  return (
    <div className='wtfPageTitle'>
      <h1 className='wtfPageTitle_title'>WhatTheFont</h1>
      <p className='wtfPageTitle_subTitle'>
        Instant font identification powered by the world&rsquo;s largest collection of fonts.
      </p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PageTitle/PageTitle.js